import React from "react";
import './Loading.css';
const Loading = () => {
  return (
    <div className="loadingImg">
      <picture className="loadingGif">
        <source srcSet="/images/animated_book-with-winks-flying.avifs" type="image/avif" />
        <img alt="loading" src="/images/animated_book-with-winks-flying.gif" />
      </picture>
    </div>
  );
};

export default Loading;
